import { useGetClientConfigParamsQuery } from '../../../../../utils/hooks/getClientConfigParams';

// FY26 Q3 High Value Referral LTO
// https://ab.daylight.stitchfix.com/expts/1697
export const HIGH_VALUE_REFERRALS_EXPERIMENT_NAME = 'aa.discount.fy26.q3.high_value_referrals';
export const HIGH_VALUE_REFERRALS_TREATMENT = 'promo';
export const HIGH_VALUE_REFERRALS_CONTROL = 'no_promo';
const configParamsInput = {
  offlineLookupOnly: true,
  params: [{
    name: HIGH_VALUE_REFERRALS_EXPERIMENT_NAME,
    expectedValues: [HIGH_VALUE_REFERRALS_TREATMENT, HIGH_VALUE_REFERRALS_CONTROL],
    fallbackValue: HIGH_VALUE_REFERRALS_CONTROL
  }]
};
export const useHighValueReferralsAllocation = () => {
  const {
    data
  } = useGetClientConfigParamsQuery({
    variables: {
      input: configParamsInput
    }
  });
  const allocation = data?.client?.configParams.find(({
    name
  }) => name === HIGH_VALUE_REFERRALS_EXPERIMENT_NAME)?.value ?? HIGH_VALUE_REFERRALS_CONTROL;
  return {
    allocation,
    isPromoTreatment: allocation === HIGH_VALUE_REFERRALS_TREATMENT
  };
};